export default String.raw`
$(document).ready(function() {
    refunds.init();
});

const refunds = {
    init: function() {
        this.events();
    },

    findRefundOrder: function(orderNumber, email) {
        return $.post('', {
            __action: 'Order/QuickReturnLookup',
            orderId: orderNumber,
            email: email,
            __csrf: __CSRF
        });
    },

    showForm: function() {
        $('.refunds-initial-view-js').addClass('hidden-js');
        $('.refund-form-view-js').removeClass('hidden-js');
        $('.refund-form-js input[name="orderNumber"]').trigger('focus');
    },

    clearFieldError: function(input) {
        const $input = $(input);
        $input.removeClass('validation-error-js');
        $input.closest('.form__input-wrapper').find('.form__invalid-input').addClass('hidden-js');
    },

    submitForm: async function(button) {
        const $submit = $(button);
        const $form = $submit.closest('.refund-form-js');
        const $orderInput = $form.find('input[name="orderNumber"]');
        const $emailInput = $form.find('input[name="email"]');
        const orderValue = $orderInput.val().trim();
        const emailValue = $emailInput.val().trim();
        const emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,}$/;
        let hasError = false;

        $form.find('.form__invalid-input').addClass('hidden-js');
        $form.find('.form__input-value').removeClass('validation-error-js');

        if (orderValue.length === 0) {
            $orderInput.addClass('validation-error-js');
            $orderInput.closest('.form__input-wrapper').find('.validation-required-js').removeClass('hidden-js');
            hasError = true;
        }

        if (emailValue.length === 0) {
            $emailInput.addClass('validation-error-js');
            $emailInput.closest('.form__input-wrapper').find('.validation-required-js').removeClass('hidden-js');
            hasError = true;
        } else if (emailRegex.test(emailValue)) {
            // email valid - no action needed
        } else {
            $emailInput.addClass('validation-error-js');
            $emailInput.closest('.form__input-wrapper').find('.email-valid-js').removeClass('hidden-js');
            hasError = true;
        }

        if (hasError) {
            return;
        }

        $submit.prop('disabled', true);

        try {
            const result = await refunds.findRefundOrder(orderValue, emailValue);
            const action = result.action;
            if (action.Redirect302) {
                globalThis.location.href = action.Redirect302;
                return;
            }
            app.temporaryPopupMessage(undefined, action.Message, action.Type);
        } catch (error) {
            console.error('Refund order lookup failed.', error);
            app.temporaryPopupMessage(undefined, $form.data('error'), 'err');
        } finally {
            $submit.prop('disabled', false);
        }
    },

    events: function() {
        $('body').on('click', '.start-refund-js', function() {
            refunds.showForm();
        });

        $('body').on('input', '.refund-form-js .form__input-value', function() {
            refunds.clearFieldError(this);
        });

        $('body').on('click', '.refund-form-submit-js', function(e) {
            e.preventDefault();
            refunds.submitForm(this);
        });

        $('body').on('keydown', '.refund-form-js input', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $(this).closest('.refund-form-js').find('.refund-form-submit-js').trigger('click');
            }
        });
    }
};
`